import { SectionCard, SectionCardTitle } from "@/components";
import UpdateImageGrid from "./ImageGrid";
import { UpdatesInfo } from "./UpdatesInfo";
import { Meta } from "@/components";

const Updates = () => {
  return (
    <>
    <Meta
      title="Intron - Gallery"
    />
    <SectionCard className="px-4 lg:px-[90px] mx-0 h-auto">
      <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
        <div className="lg:w-1/2 w-full lg:mt-25">
          <SectionCardTitle>Updates</SectionCardTitle>
          <p className="text-[14px] lg:text-[16px] leading-[24px] lg:leading-[28px] text-justify    text-[#415667] mt-4">
            Stay updated with the latest moments and milestones from our journey across Aquaculture, Poultry, and Ruminant sectors. 
            Explore our gallery featuring highlights from Exhibitions, Events, and CSR activities that reflect our commitment to progress 
            and farmer wellbeing. Keep visiting for fresh updates and new stories.
          </p>
        </div>
        <div className="lg:w-2/3 w-full flex justify-start lg:justify-end">
        <div className="w-fit">
          <UpdateImageGrid />
        </div>
        </div>

      </div>
    </SectionCard>
    <UpdatesInfo />
  </>
  );
};

export default Updates;
